// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3up5n","newExpiryDate":"styles_newExpiryDate__3PuAq","footer":"styles_footer__2vjfq"};